<div class="main-content">
	<div class="container-fluid">
		<div class="col-md-12">
			<div class="card">
				<div class="card-header card-header-{{color}}-6">
					<h4 class="card-title">
						<i class="material-icons" (click)="back()">arrow_left</i>
						<span class="bold">Pending payment runs</span>
					</h4>
				</div>
				<div class="card-body">
					<p class="text-muted mb-3">Runs saved for review. Open to review remittance and approve & post.</p>

					<div *ngIf="loading" class="text-center py-5">
						<mat-spinner diameter="40" class="mx-auto"></mat-spinner>
					</div>

					<div *ngIf="!loading && runs.length === 0" class="empty-state py-5 text-center">
						<p class="text-muted mb-2">No pending payment runs.</p>
						<a routerLink="/vendors-check-print" class="btn btn-primary">Create payment run</a>
					</div>

					<div *ngIf="!loading && runs.length > 0" class="runs-list">
						<div *ngFor="let run of runs" class="pending-run-card" (click)="openRun(run)">
							<div class="pending-run-card__body">
								<div class="pending-run-card__main">
									<h5 class="pending-run-card__journal">Run #{{ run.journalno }}</h5>
									<div class="pending-run-card__meta">
										<span *ngIf="run.created_by" class="meta-item">{{ run.created_by }}</span>
										<span class="meta-item">{{ formatDate(run.created_at) || formatDate(run.dateran) }}</span>
									</div>
								</div>
								<div class="pending-run-card__summary">
									<span class="summary-amount">{{ run.currency }} {{ run.totalAmount | number: '1.2-2' }}</span>
									<span class="summary-vendors">{{ run.vendorCount }} payment(s)</span>
								</div>
							</div>
							<div class="pending-run-card__actions">
								<button type="button" class="btn btn-sm btn-outline-primary" (click)="openRun(run); $event.stopPropagation()">Open</button>
								<button type="button" class="btn btn-sm btn-outline-danger" (click)="discardRun(run, $event)">Discard</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
